export enum App {
  Partnerships = 'Partnerships',
  Reporting = 'Reporting',
  Home = 'Home',
  Invoicing = 'Invoicing',
  Spotcheck = 'Spotcheck'
}

export enum AppBaseHref {
  Partnerships = '/partnerships/',
  Reporting = '/reporting/',
  Home = '/',
  Invoicing = '/invoicing/',
  Spotcheck = '/partnerships/spot-checks/'
}

export enum Enviroment {
  LOCAL = 'local',
  DEV = 'dev',
  QA = 'qa',
  PROD = 'prod'
}

export interface EnvironmentVariables {
  appName: App;
  baseUrl: string;
  publicUrl: string;
  environment: string;
  authUrl: string;
  logoutUrl: string;
  authenticationClientId: string;
  authRedirectUrl: string;
  authLogoutRedirectUrl: string;
  transifexToken: string;
  sentryDsn: string;
  reactAppBaseRoute: string;
  deployedOnRootPath?: boolean;
  supportedLanguages: string;
  enableReportingBulkApproval?: boolean;
  enableReportingQuality?: boolean;
  enableFlaCpcNfrAdditionalApprovers?: boolean;
  enablePartnershipsOverviewPage: boolean;
  enableFlaCpcNfrParallelSigning?: boolean;
}
